import { breakpointSizes } from 'components/utils/breakpoint'

export const DesktopLayoutSizes = `@media (min-width: ${breakpointSizes.tablet.min}px) and (max-width: ${breakpointSizes.tablet.max}px), (min-width: ${breakpointSizes.largeDesktop.min}px)`
